import React, { useEffect, useRef  } from 'react'

import { Dialog } from '@progress/kendo-react-dialogs';

// const CustomTitleBar = ({ tikNum, vahadaData }) => {
//     return (
//         <div >
//             <div>
//                 <span>{`מערכת ${vahadaData.systemName} `}</span>
//                 <span>|</span>
//                 <span>{` תיק ${tikNum} `}</span>
//                 <span>|</span>
//                 <span>{` ${vahadaData.descSugDiun}`}</span>
//             </div>

//             <div>
//                 {
//                     vahadaData.descrHahlata ? 
//                     <>
//                         <span>
//                             <b>{`${vahadaData.sugReshumaHahlata} מתאריך `}</b>
//                             {`${vahadaData.taarihDiun}: ${vahadaData.descrHahlata}`}
//                         </span>
//                         <br />
//                     </>
//                         :
//                         ""
//                 }
//                 <span>
//                     {vahadaData.taarihTokefHahlata ? <b>{`תום תוקף החלטה: `}</b> : "" }
//                     {`${vahadaData.taarihTokefHahlata ? vahadaData.taarihTokefHahlata : "" }`}
//                 </span>
//             </div>
//         </div>
//     );
// };

const VahadaDialog = ({ closeDialog, vahadaDialogData }) => {

    const modalTitleRef = useRef();
    const modalContentRef = useRef();
    
    useEffect(() => {
        const handlePrintShortcut = (e) => {
            if (e.ctrlKey && (e.key === 'p' || e.keyCode === 80)) {
                console.log("פעולת הדפסה!");
                e.preventDefault(); // Prevent default printing behavior
                printContent(); // Call the print function
            }
        };

        document.addEventListener('keydown', handlePrintShortcut);

        // Cleanup the event listener
        return () => {
            document.removeEventListener('keydown', handlePrintShortcut);
        };
    }, []);

    const printContent = () => {
        const printWindow = window.open('', '_blank', 'width=800,height=600');
        const modalTitleContent = modalTitleRef.current.innerHTML;
        const modalContentContent = modalContentRef.current.innerHTML;
        console.log('modalTitleContent', modalTitleContent);
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title> החלטת הוועדה בתיק מספר ${vahadaDialogData.tikNum}</title>
                    <style>
                        body { font-family: Arial, sans-serif; text-align: right; }
                    </style>
                </head>
                <body>
                    ${modalTitleContent}
                    <hr/>
                    ${modalContentContent}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();

        // const printWindow = window.open('', '_blank', 'width=800,height=600');
        // const modalTitleContent = modalRef.current.innerHTML;
        // printWindow.document.write('<html><head><title>Print</title>');
        // printWindow.document.write('</head><body>');
        // printWindow.document.write(modalTitleContent);
        // printWindow.document.write('</body></html>');
        // printWindow.document.close();
        // printWindow.print();
    };


    return (
        // <Dialog title={<CustomTitleBar tikNum={vahadaDialogData.tikNum} vahadaData={vahadaDialogData} />} onClose={closeDialog} width={1000} height={500} style={{ overflow: 'hidden' }}>
        <div className="dialogVaada" style={{ width: "100%", maxWidth: "700px", overflow: "auto" }} > {/* Didn't effect, why? is the Dialog have his own css?? */}
            {/* <Dialog title={<CustomTitleBar ref={modalRef} tikNum={vahadaDialogData.tikNum} vahadaData={vahadaDialogData} />} onClose={closeDialog} >  */}
            {/* <Dialog title={<CustomTitleBar tikNum={vahadaDialogData.tikNum} vahadaData={vahadaDialogData} />} onClose={closeDialog} > */}
            <Dialog title={
                <div ref={modalTitleRef} className="dialogTitle">
                    <div>
                        <span>{`מערכת ${vahadaDialogData.systemName} `}</span>
                        <span>|</span>
                        <span>{` תיק ${vahadaDialogData.tikNum} `}</span>
                        <span>|</span>
                        <span>{` ${vahadaDialogData.descSugDiun}`}</span>
                    </div>

                    <div>
                        {
                            vahadaDialogData.descrHahlata ?
                                <>
                                    <span>
                                        <b>{`${vahadaDialogData.sugReshumaHahlata} מתאריך `}</b>
                                        {`${vahadaDialogData.taarihDiun}: ${vahadaDialogData.descrHahlata}`}
                                    </span>
                                    <br />
                                </>
                                :
                                ""
                        }
                        <span>
                            {vahadaDialogData.taarihTokefHahlata ? <b>{`תום תוקף החלטה: `}</b> : ""}
                            {`${vahadaDialogData.taarihTokefHahlata ? vahadaDialogData.taarihTokefHahlata : ""}`}
                        </span>
                    </div>
                </div>
                } onClose={closeDialog} 
                width={1000} height={600} 
                
            >
                    {/* <div style={{ textAlign: "right", marginLeft: "200px" }} dangerouslySetInnerHTML={{ __html: vahadaDialogData.hamhahTochen }} /> */}
                    <div ref={modalContentRef} style={{ textAlign: "right", marginLeft: "200px" }} dangerouslySetInnerHTML={{ __html: vahadaDialogData.hamhahTochen }} />
                    {/* <div style={{ textAlign: "right" }} dangerouslySetInnerHTML={{ __html: vahadaDialogData.hamhahTochen }} /> */}
            </Dialog>
        </div>
        
    )
}

export default VahadaDialog;